import React from 'react';

interface CollapsableProps {
  open: boolean;
  header: React.ReactNode;
  children: React.ReactNode;
}

export default function Collapsable({ open, header, children }: CollapsableProps) {
  const headerBackground = open ? 'bg-gray-default' : '';

  return (
    <div className='rounded-2 border border-gray-default'>
      <div className={`${headerBackground} rounded-t-2`}>{header}</div>
      {open && <div className='*:border-t *:border-gray-default'>{children}</div>}
    </div>
  );
}
